import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';
import { Skeleton } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';

const QuickFilterSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_150};
  padding-bottom: 48px !important;
`;

const TagsContainer = styled.div`
  display: flex;
  max-height: 68px;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${SYS_SPACE_FIXED_150};
  flex-wrap: wrap;
`;

export const QuickFilterTagsSkeleton: React.FC = () => {
  return (
    <QuickFilterSkeletonContainer>
      <Skeleton variant="rectangular" width="150px" height="12px" />
      <TagsContainer>
        <Skeleton variant="rectangular" width="96px" height="28px" />
        <Skeleton variant="rectangular" width="96px" height="28px" />
        <Skeleton variant="rectangular" width="96px" height="28px" />
        <Skeleton variant="rectangular" width="96px" height="28px" />
      </TagsContainer>
    </QuickFilterSkeletonContainer>
  );
};
const BasicFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
`;

export const QuickFilterBasicSkeleton: React.FC = () => {
  return (
    <QuickFilterSkeletonContainer>
      <Skeleton variant="rectangular" width="150px" height="12px" />
      <BasicFiltersContainer>
        <Skeleton variant="rectangular" width="156px" height="56px" />
        <Skeleton variant="rectangular" width="156px" height="56px" />
      </BasicFiltersContainer>
    </QuickFilterSkeletonContainer>
  );
};

export const QuickFilterRateSkeleton: React.FC = () => {
  return (
    <QuickFilterSkeletonContainer>
      <Skeleton variant="rectangular" width="150px" height="12px" />
      <Skeleton variant="rectangular" width="257px" height="48px" />
    </QuickFilterSkeletonContainer>
  );
};

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_150};
`;

export const QuickFilterListSkeleton: React.FC = () => {
  return (
    <QuickFilterSkeletonContainer>
      <Skeleton variant="rectangular" width="150px" height="12px" />
      <ListContainer>
        <Skeleton variant="rectangular" width="257px" height="12px" />
        <Skeleton variant="rectangular" width="257px" height="12px" />
        <Skeleton variant="rectangular" width="257px" height="12px" />
      </ListContainer>
    </QuickFilterSkeletonContainer>
  );
};

const ColorContainer = styled.div`
  display: flex;
  max-height: 116px;
  max-width: 257px;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${SYS_SPACE_FIXED_200};
  flex-wrap: wrap;
`;

export const QuickFilterColorSkeleton: React.FC = () => {
  return (
    <QuickFilterSkeletonContainer>
      <Skeleton variant="rectangular" width="150px" height="12px" />
      <ColorContainer>
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
        <Skeleton variant="circular" width="42px" height="42px" />
      </ColorContainer>
    </QuickFilterSkeletonContainer>
  );
};
